// extracted by mini-css-extract-plugin
module.exports = {"blockquote":"CitationBox_blockquote__kPjoi","citation":"CitationBox_citation__UYWwx","autor":"CitationBox_autor__i73nj"};